<div class="container r">
    <button   class="btn btn-border btn-outline-warning text-light" [routerLink]="'/'"  ><h6>  Home</h6></button>
<div class=" register rcorners2 col-md-10 offset-1">
                <div class="row">
                    <div class="col-md-3 register-left">
                        <img src="https://image.ibb.co/n7oTvU/logo_white.png" alt=""/>
                        <h3>Welcome</h3>
                        <p><b> To Help The Needy <br>
                            List The Books</b></p>
                    </div>
                    <div class="col-md-9 register-right">
                        <ul class="nav nav-tabs nav-justified" id="myTab" role="tablist">
                            <li class="nav-item" (click)="[lval=true,errorMessage=null,successMessage=null]">
                                <a [ngClass]="{'nav-link active':lval}"  >Login</a>
                            </li>
                            <li class="nav-item" (click)="[lval=false,errorMessage=null,successMessage=null]">
                                <a [ngClass]="{'nav-link active' :!lval}"  >Sign Up</a>
                            </li>
                        </ul>
                        <div class="tab-content" id="myTabContent">
                            <div class="tab-pane fade show active" *ngIf="lval==true">
                                <h3 class="register-heading">LOGIN</h3>
                                <div class=" row  register-form">
                                    <div class="col-md-6 offset-3">
                                       <form class="form" [formGroup]="loginForm" (ngSubmit)="login()"> 
                                           <div class="form-group">
                                           
                                        <label for="customerId">USER ID :</label>
                                            <input type="text" id="customerId" formControlName="customerId" class="form-control" placeholder="User Id *" />
                                        </div>
                                        <div class="form-group">
                                            <label for="password">PASSWORD :</label>
                                            <input type="password" id="password" formControlName="password" class="form-control" placeholder="Password *" />
                                        </div>
                                   
                                       
                                        <button type="submit" class="btn  btn-primary">LOGIN</button>
                                        <br><h6 class="text-danger">{{errorMessage}}</h6>
                                    </form></div>
                                  
                                   
                                </div>
                            </div>
                            <div class="tab-pane fade show active" *ngIf="lval==false">
                                <h3  class="register-heading">Register </h3>
                                <div class="row register-form">
                                    <div class="col-md-9 ">
                                        <form class="form" [formGroup]="signUpform" (ngSubmit)="signUp()"> <div class="form-group">
                                       
                                        <div class="form-group">
                                            <input type="text" class="form-control"  id="customerName" formControlName="customerName" placeholder="Name *" value="" />
                                        </div>
                                        <div class="form-group">
                                            <input type="text" class="form-control"  id="collegeName" formControlName="collegeName" placeholder="College Name *" value="" />
                                        </div>
                                        <div class="form-group">
                                            <input type="number" class="form-control"  id="contactNumber" formControlName="contactNumber" placeholder="Phone *" value="" />
                                        </div>
                                        <div class="form-group">
                                            <input type="text" class="form-control" id="customerId" formControlName="customerId" placeholder="UserId *" value="" />
                                        </div>
                                    <div >
                                        <div class="form-group">
                                            <input type="password" class="form-control" placeholder="Password *"  id="password" formControlName='password'/>
                                        </div>
                                     
                                       <button type="submit" class="btn btn-success">Register</button><br>
                                       <h6 class="text-success">{{successMessage}}</h6>
                                       <h6 class="text-danger">{{errorMessage}}</h6>
                                    </div></div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>